import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=183cc71d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=183cc71d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183cc71d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183cc71d')) {
      api.createRecord('183cc71d', component.options)
    } else {
      api.reload('183cc71d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=183cc71d&scoped=true&", function () {
      api.rerender('183cc71d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4m2f5diDqYNAV/JS/comp/Voucher.vue"
export default component.exports